import { useState } from "react";

import { Popover, PopoverHeader, PopoverBody, Button } from "reactstrap";

function AddressBookListItem(props) {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  function deleteAddressClickHandler() {
    props.onDeleteClickHandler(props.address);
  }

  return (
    <tr>
      <td style={{ width: "22%" }}>
        <button
          className="btn btn-sm btn-primary"
          onClick={() => props.onSelectClickHander(props.address)}
        >
          Select
        </button>
      </td>
      <td style={{ width: "24%" }}>
        <strong>
          {props.address.Title && <span>{props.address.Title}&nbsp;</span>}
          {props.address.FirstName}&nbsp;{props.address.LastName}{" "}
        </strong>
      </td>
      <td style={{ width: "24%" }}>
        {props.address.Country && (
          <span>
            <span dangerouslySetInnerHTML={{ __html: props.address.Address1 + (props.address.Address2 ? `<br />${props.address.Address2}` : "") }} />
            <br />
            {props.address.City},&nbsp;{props.address.StateProvince}&nbsp;
            {props.address.ZipPostalCode}
            <br />
            {props.address.Country}<br />
          </span>
        )}
        {props.address.EmailAddress && (
          <span>
            <a href="mailto:{props.address.EmailAddress}">
              {props.address.EmailAddress}
            </a>
          </span>
        )}
      </td>
      <td align="right" style={{ width: "30%" }}>
        <button
          className="btn btn-sm btn-primary"
          onClick={() => props.onEditClickHandler(props.address)}
        >
          Edit
        </button>{" "}
        <Button
          size="sm"
          color="primary"
          id={`Popover${props.address.Id}`}
          onClick={() => setShowDeleteConfirm(true)}
        >
          Delete
        </Button>
        <Popover flip target={`Popover${props.address.Id}`} isOpen={showDeleteConfirm}>
          <PopoverHeader>Delete: Are You Sure?</PopoverHeader>
          <PopoverBody>
            <Button
              size="sm"
              color="primary"
              onClick={deleteAddressClickHandler}
            >
              Yes
            </Button>{" "}
            <Button
              type="button"
              size="sm"
              color="secondary"
              onClick={() => setShowDeleteConfirm(false)}
            >
              No
            </Button>
          </PopoverBody>
        </Popover>
      </td>
    </tr>
  );
}

export default AddressBookListItem;
